import React, { useEffect } from 'react';
import './intro.css';
import bgimg from '../../assets/intro-img2.png';
import bgicon from '../../assets/suitcase.png';
import { Link } from 'react-scroll';
import AOS from 'aos';

const Intro = () => {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section className="intro" id='home'>
      <div className='container intro-container col-lg-12 align-items-center mt-5 d-flex flex-wrap justify-content-center justify-content-lg-between'>
        <div className='col-lg-6' data-aos="fade-up"> 
          <h6 className='hello'><span className="introText">Hello </span></h6>
          <h1 className='introText'>I'm <span className="introText">Ciddarth RM - </span><br/>Frontend Developer</h1>
          <p className="introPara">Experienced Frontend Developer skilled in building responsive, high-performing websites using React.js, Django, HTML, CSS, and JavaScript, along with no-code platforms like WordPress (Elementor), Framer, Webflow, and eCommerce platforms like Shopify. Proficient in integrating and customizing Zoho tools such as CRM, Forms, Analytics, and SalesIQ to enhance customer data management and engagement.</p>
          <Link to="contact" smooth={true} duration={500}><button type="button" className="btn btn-light d-flex align-items-center gap-2"><img src={bgicon} alt='' className='bgicon' /> Hire Me</button></Link>
        </div>
        <div className='bg-img col-lg-5' data-aos="fade-up"> 
          <img src={bgimg} alt='' className='bgimg rounded' />
        </div>
      </div>
    </section>
  );
}

export default Intro;
